import { ComponentType } from 'react'

import { Role } from '@/types/auth'

import {
    ControllerDashboard,
    MileageClerkDashboard,
    PerformanceManagerDashboard,
    ReaderDashboard,
} from '@/pages/Dashboard'
import { MileageClerkDisruptions, ControllerDisruptions, AllDisruptions, ReaderDisruptions } from '@/pages/Disruptions'
import { ReaderVehicleAllocation, VehicleAllocation } from '@/pages/VehicleAllocation'
import { ErrorPage } from '@/pages/ErrorPage'
import { LoginPage } from '@/pages/Login'
import { PermissionDeniedPage } from '@/pages/PermissionDenied'
import { PerformanceManagerUnfinishedRecords, UnfinishedRecords } from '@/pages/UnfinishedRecords'
import { ControllerVehicleAllocationPage } from '@/pages/VehicleAllocationController'
import { AreasPage } from '@/pages/Areas'
import { SharedLogPage } from '@/pages/SharedLog'
import { SharedDisruptions } from '@/pages/SharedDisruptions'
import { ControlSheetPage } from '@/pages/ControlSheet'
import { FlaggedRecords } from '@/pages/Flagged'

interface Route {
    path: string
    Component: ComponentType
}

export interface ProtectedRoute {
    path: string
    components: Partial<Record<Role, ComponentType>>
}

export const ROUTES = {
    LOGIN: '/',
    HOME: '/logs',
    SHARED_LOG: '/logs/shared',
    CONTROL_SHEET: '/controlsheet',
    DISRUPTIONS: '/disruptions',
    SHARED_DISRUPTIONS: '/disruptions/shared',
    ALL_DISRUPTIONS: '/all-disruptions',
    FLAGGED: '/flagged',
    UNFINISHED_RECORDS: '/records',
    NO_PERMISSION: '/no-permission',
    VEHICLE_ALLOCATION: '/logs/vehicle-allocation',
    AREAS: '/areas',
    ERROR: '/error',
}

export const publicRoutes: Route[] = [
    { path: ROUTES.LOGIN, Component: LoginPage },
    { path: ROUTES.NO_PERMISSION, Component: PermissionDeniedPage },
    { path: ROUTES.ERROR, Component: ErrorPage },
]
export const protectedRoutes: ProtectedRoute[] = [
    {
        path: ROUTES.AREAS,
        components: {
            [Role.PerformanceManager]: AreasPage,
        },
    },
    {
        path: ROUTES.HOME,
        components: {
            [Role.MileageClerk]: MileageClerkDashboard,
            [Role.Controller]: ControllerDashboard,
            [Role.PerformanceManager]: PerformanceManagerDashboard,
            [Role.Reader]: ReaderDashboard,
        },
    },
    {
        path: ROUTES.DISRUPTIONS,
        components: {
            [Role.MileageClerk]: MileageClerkDisruptions,
            [Role.Controller]: ControllerDisruptions,
            [Role.PerformanceManager]: ControllerDisruptions,
            [Role.Reader]: ReaderDisruptions,
        },
    },
    {
        path: ROUTES.ALL_DISRUPTIONS,
        components: {
            [Role.MileageClerk]: MileageClerkDisruptions,
            [Role.Controller]: ControllerDisruptions,
            [Role.PerformanceManager]: AllDisruptions,
            [Role.Reader]: AllDisruptions,
        },
    },
    {
        path: ROUTES.UNFINISHED_RECORDS,
        components: {
            [Role.MileageClerk]: UnfinishedRecords,
            [Role.Controller]: UnfinishedRecords,
            [Role.PerformanceManager]: PerformanceManagerUnfinishedRecords,
        },
    },
    {
        path: ROUTES.VEHICLE_ALLOCATION,
        components: {
            [Role.MileageClerk]: VehicleAllocation,
            [Role.Controller]: ControllerVehicleAllocationPage,
            [Role.PerformanceManager]: VehicleAllocation,
            [Role.Reader]: ReaderVehicleAllocation,
        },
    },
    {
        path: ROUTES.SHARED_LOG,
        components: {
            [Role.MileageClerk]: SharedLogPage,
            [Role.Controller]: SharedLogPage,
            [Role.PerformanceManager]: SharedLogPage,
            [Role.Reader]: SharedLogPage,
        },
    },
    {
        path: ROUTES.SHARED_DISRUPTIONS,
        components: {
            [Role.MileageClerk]: SharedDisruptions,
            [Role.Controller]: SharedDisruptions,
            [Role.PerformanceManager]: SharedDisruptions,
            [Role.Reader]: SharedDisruptions,
        },
    },
    {
        path: ROUTES.CONTROL_SHEET,
        components: {
            [Role.MileageClerk]: ControlSheetPage,
            [Role.Controller]: ControlSheetPage,
            [Role.PerformanceManager]: ControlSheetPage,
            [Role.Reader]: ControlSheetPage,
        },
    },
    {
        path: ROUTES.FLAGGED,
        components: {
            [Role.MileageClerk]: FlaggedRecords,
            [Role.PerformanceManager]: FlaggedRecords,
        },
    },
]
